export const mobileBreakPoint = 640;
export const minPasswordLength = 8;
export const USER_DISMISSED_REMINDERS_ENCOURAGEMENT = 'USER_DISMISSED_REMINDERS_ENCOURAGEMENT';
export const LAST_GROUP_ID_VIEWED_BY_USER = 'LAST_GROUP_ID_VIEWED_BY_USER';

